import type { PostMessageAction } from "../types/types";

import Iframe, { DEFAULT_OPTIONS, type IframeOptions } from "./iframe";

export const assertValidFunction = (candidate: Function) => {
  if (typeof candidate !== "function") {
    throw new Error(`Expected type "function", but received ${typeof candidate}`);
  }
};

class AffinityIFrame extends Iframe {
  constructor(containerElement: HTMLElement, url: string) {
    super(containerElement, url);
    this.verificationUrl = new URL(this.getAffinityUrlWithUID(url));
  }

  static createUniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }

  getAffinityUrlWithUID(url: string): string {
    const urlObj = new URL(url);
    urlObj.searchParams.set("affinityIframeUid", this.verificationIframeUid);
    return urlObj.toString();
  }

  override addWindowMessageListener(actionCb: (action: PostMessageAction) => void): void {
    const listener = (ev: MessageEvent) => {
      if (this.verificationUrl.origin !== ev.origin) {
        return;
      }

      if (ev.data.affinityIframeUid !== this.verificationIframeUid) {
        return;
      }

      if (ev.data.action && ev.data.action.type) {
        actionCb(ev.data.action);
      }
    };

    window.addEventListener("message", listener);
    this.onCleanupEvents.push(() => window.removeEventListener("message", listener));
  }

  override createIframe(options: IframeOptions): HTMLIFrameElement {
    this.iframe = document.createElement("iframe");
    this.iframe.classList.add(options.className);
    this.iframe.title = options.title;
    this.iframe.src = this.verificationUrl.href;
    this.iframe.allow = "camera;microphone";
    this.iframe.onload = () => this.onLoad();
    return this.iframe;
  }

  override init() {
    this.createIframe({ ...DEFAULT_OPTIONS, title: "SheerID Affinity Offers" });
    this.addActionListener();
    this.containerElement.appendChild(this.iframe);
  }
}

export default AffinityIFrame;
